import { WidgetFeedInstagram } from './components/WidgetFeedInstagram'
import type { InstagramAppProps } from './instagram-app.props'

export default class InstagramApp {
    constructor({
        id,
        posts,
        urlInstagram,
        legenda,
        pathMidia,
        parameter,
        iconInstagram
    }: InstagramAppProps){
        const el = document.getElementById(id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <WidgetFeedInstagram
                posts={posts}
                urlInstagram={urlInstagram}
                legenda={legenda}
                pathMidia={pathMidia}
                parameter={parameter}
                iconInstagram={iconInstagram}
            />
        )
    }
}
